// extracted by mini-css-extract-plugin
module.exports = {"smallDiv":"OverviewCard_smallDiv__361cs","count":"OverviewCard_count__3F_ll","insideText":"OverviewCard_insideText__SlIbC","mainDiv":"OverviewCard_mainDiv__RAWnx"};